// @flow
import type { Tag } from '~/core/types/beekeeper/actions/tags';
import type { ActionsState } from '~/core/state/actions/types';
import type { ConnectProps } from './types';

import { connect } from 'react-redux';
import { intersection, find } from 'lodash/fp';
import { categories, getAttributeDefinition, getFilterDevicesList } from '~/core/constants/actions';
import { deviceModels } from '~/core/constants/devices';
import { getNormalisedTemplates } from '~/core/state/actions/selectors';
import { getProductTypesUserOwns } from '~/core/state/products/selectors';
import { hasSLT1Thermostat } from '~/core/state/devices/selectors';
import { getIconLocaleSuffix } from '~/core/state/config/selectors';
import Component from './component';

const tagsToCheck = (currentFilter, region, productTypesUserOwns): ?Array<Tag> => {
    const filterByDevices = getFilterDevicesList(region, productTypesUserOwns);

    const findSelectedItem = find(c => !!currentFilter.selectedItem && c.id === currentFilter.selectedItem);

    const map = {
        BUILD_YOUR_OWN: () => ['canvas'],
        BY_CATEGORY: () => {
            const category = findSelectedItem(categories);
            return category && category.tagsAssociated;
        },
        BY_DEVICE: () => {
            const filterByDevice = findSelectedItem(filterByDevices);
            return filterByDevice && filterByDevice.tagsAssociated;
        },
        SHOW_ALL: () => {},
        WELCOME_HOME: () => ['WelcomeHomeUK', 'WelcomeHomeUS']
    };
    return map[currentFilter.name]();
};

const mapStateToProps = (state: { actions: ActionsState }, { currentFilter }: ConnectProps) => {
    const region = getIconLocaleSuffix(state);
    const list = getNormalisedTemplates(state);
    const productTypesUserOwns = getProductTypesUserOwns(state);
    const tags = tagsToCheck(currentFilter, region, productTypesUserOwns);
    const hasSLT1 = hasSLT1Thermostat(state);
    const templates = list.reduce((acc, template) => {
        if (
            (tags && intersection(template.tags, tags).length === 0) ||
            (hasSLT1 && template.incompatible.includes(deviceModels.SLT1))
        ) {
            return acc;
        }
        const groupIcons = ['when', 'while', 'then'].reduce(
            (groups, group) => ({
                ...groups,
                [group]: template[group].reduce((acc, templateEvent) => {
                    const definition = {
                        required: templateEvent.required,
                        ...getAttributeDefinition(templateEvent.type, region)
                    };
                    return definition ? [...acc, definition] : acc;
                }, [])
            }),
            {}
        );

        return [
            ...acc,
            {
                description: template.description,
                id: template.id,
                name: template.name,
                incompatible: template.incompatible,
                ...groupIcons
            }
        ];
    }, []);

    return { productTypesUserOwns, region, templates };
};

// $FlowFixMe
export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/discover-actions/index.js